import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import moment from 'moment';
import { USER_OPERATIONS } from 'helper';
import { RootState } from 'interfaces';
import { ERealEstateReportStatus, IRealEstateReport } from '../interfaces';
import { useDownloadRealEstateReport } from '../hooks';

interface IProps {
  report: IRealEstateReport;
  disabled?: boolean;
  onDraft?: (report: IRealEstateReport) => void;
  onPublish?: (report: IRealEstateReport) => void;
  onReplaceFile?: (report: IRealEstateReport) => void;
}

const RealEstateReport: React.FC<IProps> = ({ report, disabled, onDraft, onPublish, onReplaceFile }) => {
  // Global data
  const operations = useSelector((state: RootState) => state.operations);

  const { downloadFile, loading: downloadFileLoading } = useDownloadRealEstateReport();

  return (
    <Box
      component={(props) => <Paper {...props} variant="outlined" />}
      sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 3 }}
    >
      <Box>
        <Typography variant="h5">
          <b>{report.reportName}</b>
        </Typography>

        <Typography variant="caption" color="textSecondary">
          {report.isPublic
            ? `Опубликован ${report.date ? `: ${moment(report.date).format('LL')}` : ''}`
            : 'Не опубликован'}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gridGap: 8 }}>
        {operations.includes(USER_OPERATIONS.REAL_ESTATE_REPORT_OPERATION) && (
          <>
            {[ERealEstateReportStatus.PUBLISHED].includes(report.status) && (
              <Button color="primary" variant="outlined" disabled={disabled} onClick={() => onDraft?.(report)}>
                Отозвать
              </Button>
            )}

            {[ERealEstateReportStatus.DRAFT].includes(report.status) && (
              <Button color="primary" variant="outlined" disabled={disabled} onClick={() => onPublish?.(report)}>
                Опубликовать
              </Button>
            )}
          </>
        )}

        {[ERealEstateReportStatus.NEW, ERealEstateReportStatus.DRAFT, ERealEstateReportStatus.PUBLISHED].includes(
          report.status,
        ) && (
          <Button
            color="primary"
            variant="outlined"
            disabled={disabled || downloadFileLoading}
            onClick={() => downloadFile(report.reportFiles[0])}
          >
            Скачать
          </Button>
        )}

        {[ERealEstateReportStatus.NEW, ERealEstateReportStatus.DRAFT].includes(report.status) && (
          <Button color="primary" variant="outlined" disabled={disabled} onClick={() => onReplaceFile?.(report)}>
            Добавить файл отчета
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default RealEstateReport;
